// utils/logger.ts
const isProduction = process.env.NODE_ENV === 'production';

export const logger = {
    log: (...args: any[]) => {
        if (!isProduction) {
            console.log(...args);
        }
    },
    warn: (...args: any[]) => {
        if (!isProduction) {
            console.warn(...args);
        }
    },
    error: (...args: any[]) => {
        // エラーは本番環境でも見たい場合が多い
        console.error(...args);
    },
    info: (...args: any[]) => {
        if (!isProduction) {
            console.info(...args);
        }
    },
};

// 使用例
// import { logger } from '../utils/logger';
// logger.log('ユーザーデータ:', user);
// logger.error('認証エラー:', error);